import { render } from "./index.vue?vue&type=template&id=c6b11a1c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=c6b11a1c&scoped=true&lang=css"

import exportComponent from "G:\\zhongfu\\web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6b11a1c"]])

export default __exports__